import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Brand } from "@unleashed/models/Brand";

type AuthStatus = "unauthenticated" | "authenticated" | "authorized";

export interface AuthState {
  status: AuthStatus;
  accessToken?: string;
  name?: string;
  initials?: string;
  username?: string;
  permissions?: Brand[];
}

const initialState: AuthState = {
  status: "unauthenticated",
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        accessToken: action.payload,
      };
    },
    setPermissions: (state, action: PayloadAction<Brand[]>) => {
      return {
        ...state,
        permissions: action.payload,
        status: "authorized",
      };
    },
    signIn: (state, action: PayloadAction<{
      name?: string,
      username?: string,
      initials?: string,
      accessToken?: string,
    }>) => {
      return {
        ...state,
        ...action.payload,
        status: "authenticated",
      };
    },
    signOut: () => {
      return {
        status: "unauthenticated" as AuthStatus,
      };
    },
  },
});

export const {
  setAccessToken,
  setPermissions,
  signIn,
  signOut
} = AuthSlice.actions;
